import { cn } from "@/lib/utils";

interface LoaderProps {
  className?: string;
}

export function Loader({ className }: LoaderProps) {
  return (
    <div
      className={cn(
        "h-1 w-full rounded-full bg-muted relative overflow-hidden",
        className
      )}
    >
      <div className="absolute inset-0 animate-loading-gradient" />
    </div>
  );
}
